import { InsuredTripCancelRequest } from "./insured-trip-cancel-request";
import { InsuredTripRequest } from "./insured-trip-request";

export class InsuredTripUpdateRequest {
  insuredTripCancelRequest: InsuredTripCancelRequest;
  insuredTripRequest: InsuredTripRequest;
  newDateBegin?: string;
}
